import gql from 'graphql-tag';
import {
  DocumentMetadata,
  DownloadMetadata,
  MediaMetadata,
  TextMetadata,
} from '../../definitions/schemas';
import { TrackEvent } from '../../enums/Content/TrackEvent';
import Interface from '../Interface';

interface TrackInput {
  roomId: string;
  contentId: string;
  event: TrackEvent;
  measure: number;
  metadata?: DocumentMetadata | DownloadMetadata | MediaMetadata | TextMetadata;
  version: number;
  skip?: boolean;
}

export default class TrackInterface extends Interface {
  public async track(input: TrackInput) {
    return this.mutate<null>(async () => {
      const response = await this.apolloService.executeMutation({
        mutation: gql`
          mutation track($input: TrackInput!) {
            track(input: $input) {
              errors
            }
          }
        `,
        variables: {
          input,
        },
      });

      const { errors, message } = response.data.track;

      return {
        data: null,
        serverErrors: errors,
        serverMessage: message,
      };
    }, 'Error tracking an event');
  }
}
